const API_HTTP = process.env.REACT_APP_BACKEND_URL;

// Portraits live at /api/personas/{id}.png (800×1000). The backend also serves
// WebP renditions at {id}-240.webp / {id}-480.webp / {id}-800.webp (~5-70 KB
// vs ~1 MB for the PNG), so every renderer should go through this component.
export function portraitSources(portrait) {
  if (!portrait) return null;
  const abs = portrait.startsWith("http") ? portrait : `${API_HTTP}${portrait}`;
  if (!abs.endsWith(".png")) return { src: abs, srcSet: undefined };
  const base = abs.slice(0, -4);
  return {
    src: `${base}-800.webp`,
    srcSet: `${base}-240.webp 240w, ${base}-480.webp 480w, ${base}-800.webp 800w`,
  };
}

export default function PortraitImg({
  portrait,
  alt = "",
  sizes = "(max-width: 768px) 45vw, 320px",
  className = "",
  loading = "lazy",
  ...rest
}) {
  const s = portraitSources(portrait);
  if (!s) return null;
  return (
    <img
      src={s.src}
      srcSet={s.srcSet}
      sizes={s.srcSet ? sizes : undefined}
      alt={alt}
      className={className}
      loading={loading}
      decoding="async"
      {...rest}
    />
  );
}
